/**
 * ProgressBar — thin colored progress bar for subject cards and aggregate displays.
 *
 * Usage:
 *   <ProgressBar completed={3} total={14} color="#F59E0B" />
 *   <ProgressBar completed={0} total={38} color="#38BDF8" />
 *
 * PROGRESS-BAR-STATUS:
 * progress-bar.js created: YES
 */

const ProgressBar = ({ completed = 0, total = 1, color = '#38BDF8', height = 4, style = {} }) => {
  const percentage = total > 0 ? Math.min((completed / total) * 100, 100) : 0;

  // Track color = main color at 18% opacity (visible even on white cards)
  const r = parseInt(color.slice(1, 3), 16);
  const g = parseInt(color.slice(3, 5), 16);
  const b = parseInt(color.slice(5, 7), 16);
  const trackColor = `rgba(${r},${g},${b},0.18)`;

  return (
    <div
      style={{
        width: '100%',
        height: height,
        borderRadius: height / 2,
        backgroundColor: trackColor,
        overflow: 'hidden',
        ...style,
      }}
    >
      <div
        style={{
          width: `${percentage}%`,
          height: '100%',
          borderRadius: height / 2,
          backgroundColor: color,
          transition: 'width 0.5s ease',
          minWidth: completed > 0 ? height : 0,
        }}
      />
    </div>
  );
};

export default ProgressBar;
